import styled from 'styled-components';
import {device} from '../../../styled/device';
import {Button} from '../../../components/Button';

export const Title = styled.h1`
  font-family: Poppins-Regular, sans-serif;
  font-weight: 500;
  font-size: 30px;
  max-width: 400px;
  margin: 0;
`;

export const Description = styled.div`
  font-family: Poppins-Regular, sans-serif;
  font-size: 16px;
  margin: 10px auto 0;
`;

export const ButtonModal = styled(Button)`
  margin: 0 auto;
  justify-content: center;

  @media (max-width: ${device.mobileL}) {
    height: 48px;
    min-width: 211px;
  }
`;
